import { render } from "./RegionalCulturesSection.vue?vue&type=template&id=89937654&scoped=true"
import script from "./RegionalCulturesSection.vue?vue&type=script&lang=js"
export * from "./RegionalCulturesSection.vue?vue&type=script&lang=js"

import "./RegionalCulturesSection.vue?vue&type=style&index=0&id=89937654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89937654"]])

export default __exports__